<template>
  <div class="displayNote">
    <div class="displayNote__icon">
      <DisplayIcon :id="note.iconID" />
    </div>
    <div class="displayNote__content">
      <p class="displayNote__headline">
        {{ note.headline }}
      </p>
      <p>{{ note.description }}</p>
      <DisplayLinks :links="note.links" />
      <p
        v-if="note.versionNumber"
        class="displayNote__version"
      >
        (Version {{ note.versionNumber }}, {{ note.publishDate | HumanDate }})
      </p>
      <p
        v-if="note.isInherited"
        class="displayNote__version"
      >
        Nedarvet
      </p>
    </div>
  </div>
</template>

<script>
import DisplayLinks from './DisplayLinks.vue';
import DisplayIcon from './DisplayIcon.vue';
import HumanDate from '../filters/HumanDate';

export default {
    name: 'DisplayNote',
    components: {
        DisplayIcon, DisplayLinks,
    },
    filters: { HumanDate },
    props: {
        note: { type: Object, required: true },
    },
};
</script>

<style lang="scss" scoped>
.displayNote {
    display: flex;

    &:not(:last-child) {
        margin-bottom: 30px;
    }

    &__icon {
        min-width: 40px;
        max-width: 40px;
    }

    &__content {
        flex-grow: 1;
    }

    &__headline {
        font-weight: bold;
        margin-bottom: 5px;
    }
    &__version {
        padding-top: 5px;
        font-size: 12px;
        font-style: italic;
    }
}
</style>
